document.addEventListener('DOMContentLoaded', function () {
  var allTabs = document.querySelectorAll('.product-details-tab');

  allTabs.forEach(function (container) {
    var items = Array.from(container.querySelectorAll('.productq-ans'));
    if (items.length === 0) return;

    // Create left/right columns
    var leftCol = document.createElement('div');
    leftCol.className = 'product-details-column left-column';
    var rightCol = document.createElement('div');
    rightCol.className = 'product-details-column right-column';

    // Reset container and append columns
    container.innerHTML = '';
    container.appendChild(leftCol);
    container.appendChild(rightCol);

    // ✅ Find tab containing exactly "Maße & Lieferumfang"
    var sizeTab = items.find(item => {
      const title = item.querySelector('.productquestions')?.textContent.trim().toLowerCase();
      return title && title.includes('maße & lieferumfang');
    });

    // Split items between columns
    items.forEach(function (item, idx) {
      if (item === sizeTab) {
        rightCol.appendChild(item);
      } else if (idx % 2 === 0) {
        leftCol.appendChild(item);
      } else {
        rightCol.appendChild(item);
      }
    });

    // Accordion behavior
    var questions = container.querySelectorAll('.productquestions');
    var answers = container.querySelectorAll('.productanswercont');

    // ✅ Ensure all tabs start closed
    questions.forEach(q => q.classList.remove('active'));
    answers.forEach(a => (a.style.maxHeight = 0));

    questions.forEach(function (q) {
      q.addEventListener('click', function () {
        // close all other tabs
        questions.forEach(function (other) {
          if (other !== q) {
            other.classList.remove('active');
            const otherAns = other.nextElementSibling;
            if (otherAns) otherAns.style.maxHeight = 0;
          }
        });

        // toggle clicked tab
        q.classList.toggle('active');
        const ans = q.nextElementSibling;
        if (ans) {
          ans.style.maxHeight = q.classList.contains('active')
            ? ans.scrollHeight + 'px'
            : 0;
        }
      });
    });
  });
});


// ✅ Keep variant logic as-is (unchanged)
document.addEventListener('DOMContentLoaded', () => {
  function hideAllBlocks() {
    document.querySelectorAll('.variant-extra-content').forEach(div => {
      div.style.display = 'none';
    });
  }

  function showBlockForVariantId(id) {
    if (!id) return;
    hideAllBlocks();
    const el = document.getElementById('variant-extra-' + id);
    if (el) el.style.display = 'block';
  }

  function getSelectedVariantId() {
    const idInputChecked = document.querySelector('input[name="id"]:checked, input[name="id"]');
    if (idInputChecked && idInputChecked.value) return idInputChecked.value;

    const idSelect = document.querySelector('select[name="id"]');
    if (idSelect && idSelect.value) return idSelect.value;

    const productFormIdInput = document.querySelector('form[action^="/cart/add"] input[name="id"]');
    if (productFormIdInput && productFormIdInput.value) return productFormIdInput.value;

    const variantSelectsEl = document.querySelector('variant-selects, [data-variant-selects], [data-product-form]');
    if (variantSelectsEl) {
      const dataId = variantSelectsEl.dataset.currentVariant || variantSelectsEl.dataset.selectedVariant || variantSelectsEl.getAttribute('data-current-variant');
      if (dataId) return dataId;
      const jsonScript = variantSelectsEl.querySelector('script[type="application/json"]');
      if (jsonScript) {
        try {
          const variants = JSON.parse(jsonScript.textContent || '[]');
          if (variants && variants.length) {
            if (variants.length === 1) return variants[0].id;
            const firstAvailable = variants.find(v => v.available) || variants[0];
            if (firstAvailable && firstAvailable.id) return firstAvailable.id;
          }
        } catch (e) {}
      }
    }

    const anyDataVariant = document.querySelector('[data-variant-id]');
    if (anyDataVariant) return anyDataVariant.getAttribute('data-variant-id');
    return null;
  }

  const initialId = getSelectedVariantId();
  if (initialId) showBlockForVariantId(initialId);

  document.body.addEventListener('variant:change', function(event) {
    try {
      const variant = event.detail && event.detail.variant;
      if (variant && (variant.id || variant.id === 0)) {
        showBlockForVariantId(variant.id);
        return;
      }
    } catch (e) {}

    const id = getSelectedVariantId();
    if (id) showBlockForVariantId(id);
  });

  const container = document.querySelector('variant-selects') || document;
  container.addEventListener('change', function() {
    setTimeout(() => {
      const id = getSelectedVariantId();
      if (id) showBlockForVariantId(id);
    }, 10);
  });

  container.addEventListener('click', function() {
    setTimeout(() => {
      const id = getSelectedVariantId();
      if (id) showBlockForVariantId(id);
    }, 10);
  });
});
